import { SearchPagination } from '../BillSearch';

export default class PagingDefault implements SearchPagination {
  limit = 50; // Or whatever we agree our "default" paging to be
}
